import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
  Card,
  Autocomplete,
  CardMedia,
  Avatar,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import "react-lazy-load-image-component/src/effects/blur.css";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseExpert } from "./UseExpert";
import { useSnackbar } from "notistack";
import { FileUploader } from "react-drag-drop-files";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ImageIcon from "@mui/icons-material/Image";
import copy from "copy-text-to-clipboard";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function ExpertreviewImagesGrid(props) {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const ImageType = [
    { id: 1, type: "بنر" },
    { id: 2, type: "محتوا" },
  ];
  const { enqueueSnackbar } = useSnackbar();
  const { GetExpertImages, AddExpertImage, DeleteExpertImage } = UseExpert();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [imageRes, setImageRes] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [openDialogImage, setOpenDialogImage] = useState({
    show: false,
    image: undefined,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    // id: 0,
    productId: "",
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: state.icon ? state.icon : "",
  });

  const handleChangeImage = (file) => {
    setState({
      ...state,
      productId: props.productId,
    });
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  useEffect(() => {
    if (props.productId) {
      setProgress(true);
      GetExpertImages(props.productId, (callback) => {
        setImageRes(callback);
      });
    }
  }, [props.productId]);

  const newFunc = () => {
    setOpenDialog(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      // hide: true,
    },
    {
      field: "image",
      width: 120,
      align: "center",
      headerName: "تصویر",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Avatar sx={{ borderRadius: 0 }} src={cellValues.row.image}></Avatar>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 200,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="نمایش">
              <IconButton
                onClick={() => {
                  setOpenDialogImage({
                    show: true,
                    image: cellValues.row.image,
                  });
                }}
              >
                <ImageIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="کپی">
              <IconButton
                onClick={() => {
                  copy(cellValues.row.image);
                  enqueueSnackbar("آدرس تصویر در کلیپ بورد شما کپی شد ", {
                    variant: "info",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                }}
              >
                <FileCopyIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
          width: "100px",
          height: "100px",
        }}
        fullWidth
        maxWidth="sm"
        open={openDialogImage.show}
        onClose={() => {
          setOpenDialogImage({
            show: false,
            image: "",
          });
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              height: "100%",
              mx: "auto",
            }}
          >
            <CardMedia
              sx={{
                mb: 4,
                minWidth: "150px",
                minHeight: "150px",
              }}
              component="img"
              alt="green iguana"
              image={openDialogImage.image}
            />
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setOpenDialogImage({
                  show: false,
                  image: "",
                });
              }}
            >
              بستن
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setState({
            productId: props.productId,
            // id: 0,
          });
          setImgState({
            file: undefined,
            url: "",
          });
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box>
                  <Card
                    sx={{
                      width: isSmall ? "300px" : "400px",
                      height: "150px",
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.url ? imgState.url : "/static/img/nobanner.jpg"
                      }
                    />
                  </Card>
                </Box>
              }
            />
            <Box sx={{ mt: 3 }}>
              <Button
                onClick={() => {
                  if (imgState.file == undefined) {
                    enqueueSnackbar("لطفا تصویر را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  } else {
                    setProgress(true);
                    AddExpertImage(state, imgState.file, () => {
                      GetExpertImages(props.productId, (callback) => {
                        setImageRes(callback);
                      });
                      setState({
                        productId: props.productId,
                        // id: 0,
                      });
                      setImgState({
                        file: undefined,
                        url: "",
                      });
                      setOpenDialog(false);
                    });
                  }
                }}
                color="secondary"
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setState({
                    productId: props.productId,
                    // id: 0,
                  });
                  setImgState({
                    file: undefined,
                    url: "",
                  });
                  setOpenDialog(false);
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <DataGrid
        className="ltr-grid"
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={imageRes ? imageRes : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={imageRes && imageRes.length ? imageRes.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount: imageRes && imageRes.length ? imageRes.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "id",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"تصویر"}
        callback={() => {
          setProgress(true);
          DeleteExpertImage(deleteState.id, () => {
            GetExpertImages(props.productId, (callback) => {
              setImageRes(callback);
            });
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
